import axios from "axios";
import { Entity } from "../../types/model/entity/Entity";
import { SessionStore } from "../../types/store";
import { newAbortSignal } from "../../utils";

const BASE_URL = `${process.env.REACT_APP_BACKEND_URL}/app/manager/entities/recent`;

export type RecentEntitiesResponse = {
  userRecent: Entity[];
  globalRecent: Entity[];
};

export const getRecentEntities = async (): Promise<RecentEntitiesResponse> => {
  const session: SessionStore | undefined = JSON.parse(
    localStorage.getItem("session") || "{}",
  );

  const userId = session?.userId;

  const response = await axios.get<RecentEntitiesResponse>(BASE_URL, {
    headers: {
      "content-type": "application/json",
      "x-access-token": session?.accessToken,
    },
    timeout: Number.parseInt(`${process.env.REACT_APP_AXIOS_TIME_OUT}`),
    signal:
      AbortSignal.timeout === undefined
        ? newAbortSignal(Number(process.env.REACT_APP_AXIOS_TIME_OUT))
        : AbortSignal.timeout(Number(process.env.REACT_APP_AXIOS_TIME_OUT)),
    params: userId ? { userId } : {},
  });

  return response.data;
};
